import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './inactive-licenses.hbs'
import inactiveLicenseItemTemplate from './inactive-license-item.hbs'
import LicenseActivation from './license-activation'
import appDisplay from 'scoreboard/components/app-display'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import SuccessDialog from 'scoreboard/components/success-dialog'
import i18n from 'scoreboard/components/i18n'

var InactiveLicenses = Backbone.View.extend({

	className: 'inactive-licenses',

	events: {
		'click .activate': 'activate',
		'click .delete': 'delete'
	},

	/**
	 * options.licenses are the inactive licenses
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template())
		var html = ''
		_.each(this.options.licenses, function(license) {
			html += inactiveLicenseItemTemplate(license)
		})
		this.$('.list').html(html)
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		return this
	},

	activate: function(e) {
		var index = this.$(e.target).closest('[data-id]').index()
		var license = this.options.licenses[index]
		if (license.pendingOrbApproval) {
			// License sent to Orb, Spider Support will approve
			appDisplay.replaceDialog(new SuccessDialog({
				title: i18n.get('admin.licenses.activation.orb'),
				message: i18n.get('admin.licenses.activation.orb.message')
			}))
		} else {
			var form = new LicenseActivation({ license: license })
			appDisplay.dialog(form)
			form.on('done', this.trigger.bind(this, 'activate:license'))
		}
	},

	'delete': function(e) {
		var index = this.$(e.target).closest('[data-id]').index()
		var license = this.options.licenses[index]
		var confirmation = new DeleteConfirmation(license)
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', function() {
			$.delete('api/admin/licenses/' + license.id, function() {
				// close the confirmation dialog
				confirmation.trigger('done')
				// fire an event so we can re-draw the list of licenses
				Backbone.trigger('delete:license', license)
			}.bind(this))
		}.bind(this))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}

})

export default InactiveLicenses

InactiveLicenses.__filename__ = 'admin/licenses/inactive-licenses.js'
